import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Grid,
} from "@mui/material";

const ExpenseForm = ({ onSubmit, onCancel, loading }) => {
  const [form, setForm] = useState({
    category: "Fuel",
    amount: "",
    paymentMethod: "Cash",
    paidBy: "",
    note: "",
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ ...form, amount: Number(form.amount) || 0 });
  };

  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Category *"
            fullWidth
            required
            disabled={loading}
            value={form.category}
            onChange={(e) => setForm({ ...form, category: e.target.value })}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Amount (₹) *"
            type="number"
            fullWidth
            required
            disabled={loading}
            value={form.amount}
            onChange={(e) => setForm({ ...form, amount: e.target.value })}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth>
            <InputLabel>Payment Method</InputLabel>
            <Select
              value={form.paymentMethod}
              label="Payment Method"
              disabled={loading}
              onChange={(e) =>
                setForm({ ...form, paymentMethod: e.target.value })
              }
            >
              <MenuItem value="Cash">Cash</MenuItem>
              <MenuItem value="UPI">UPI</MenuItem>
              <MenuItem value="Card">Card</MenuItem>
              <MenuItem value="Bank Transfer">Bank Transfer</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Paid By"
            fullWidth
            disabled={loading}
            value={form.paidBy}
            onChange={(e) => setForm({ ...form, paidBy: e.target.value })}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Note"
            fullWidth
            disabled={loading}
            value={form.note}
            onChange={(e) => setForm({ ...form, note: e.target.value })}
          />
        </Grid>
      </Grid>
      <Box sx={{ display: "flex", gap: 2, mt: 3 }}>
        <Button type="submit" variant="contained" fullWidth disabled={loading}>
          Add Expense
        </Button>
        <Button
          variant="outlined"
          color="inherit"
          onClick={onCancel}
          disabled={loading}
        >
          Cancel
        </Button>
      </Box>
    </form>
  );
};

export default ExpenseForm;
